import { Component, Input } from '@angular/core';
import { Contact } from '@salesforce/scv-connector-base';

@Component({
  selector: 'app-active-call-contact-details',
  templateUrl: './active-call-contact-details.component.html',
  styleUrls: ['./active-call-contact-details.component.css']
})
export class ActiveCallContactDetailsComponent {
  @Input() contact?: Contact;
}
